import React, { useState } from "react";
import { Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function SearchBarDesktop() {
 const [keyword, setKeyword] = useState("");
 const navigate = useNavigate();

 const submitHandler = (e) => {
   e.preventDefault();

   if (keyword?.trim()) {
     navigate(`/products?keyword=${keyword}`);
   } else {
     navigate(`/`);
   }
  };
  
  return (
    <form onSubmit={submitHandler} className="custom-navbar-search">
      <input
        type="text"
        value={keyword}
        name="keyword"
        onChange={(e) => setKeyword(e.target.value)}
        placeholder="Part No. / Keyword"
      />
      <button
        className="btn btn-primary"
        type="submit"
      >
        <Image src="/img/search.png" alt="Search" />
      </button>
    </form>
  );
}
